// @flow

// Fetch Saga Composer
import composeFetchSaga from 'fc-fetch-worker'

// WebWorker
import worker from 'fc-wrkr-environment'

export default function initialize (controller: Object): Promise<Object> {
  const terminate = function terminate () {
    if (worker) {
      worker.terminate()
    }
  }

  return new Promise((resolve: Function) => {
    terminate()

    resolve({
      terminate,
      handleFetch: composeFetchSaga({
        getWorker: function (): Worker {
          return worker.getWorker()
        },
      }),
    })
  })
}
